import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Tag, Button, Carousel } from 'antd';
import { Icon, Modal } from 'antd-mobile';
import Format from '../../utils/format';
import Toast from 'antd-mobile/lib/toast';
import { Markup } from 'interweave';
import * as SignalR from '@aspnet/signalr';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'VersionStore',
    'templateStore',
    'loginStore',
    'webSettingStore',
    'homeRetailOfferStore',
    'shoppingStore'
)
@observer
class RetailOfferClientPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dndSelected: false,
            comeBackSelected: false,
            confirmEnabled: false
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.templateStore.getActive();
        this.props.webSettingStore.getData();
        const id = this.props.match.params.id;
        this.props.homeRetailOfferStore.initRead(id);

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    componentWillUnmount() {
        this.props.homeRetailOfferStore.resetData();
    }

    back = () => {
        this.props.history.push('/');
    }

    orderClick = () => {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        confirmAlert(
            <div
                style={{
                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                    color: activeTemplate.templateSetting.label.color,
                    fontSize: activeTemplate.templateSetting.label.fontSize,
                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                }}
            >
                <span>{webSettting.shoppingOfferText}</span>
            </div>,
            <div
                style={{
                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                    color: activeTemplate.templateSetting.text.color,
                    fontSize: activeTemplate.templateSetting.text.fontSize,
                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`
                }}
            >
                <span>Are you sure to order this item?</span>
            </div>, [
            {
                text:
                    <span
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}
                    >
                        {webSettting.cancelText}
                    </span>
            },
            {
                text:
                    <span
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}
                    >
                        {webSettting.okText}
                    </span>
                , onPress: () => {
                    const { taskId } = this.props.homeRetailOfferStore;
                    const roomNo = this.props.loginStore.getRoomNo();
                    this.props.homeRetailOfferStore.setHomeRetailOfferLoading(true);
                    this.props.shoppingStore.goToShoppingConfirmPageFromRetailOffer(roomNo, taskId).then(() => {
                        this.props.homeRetailOfferStore.setHomeRetailOfferLoading(false);
                        this.props.history.push('/shopping-confirm');
                    });
                }
            }
        ])
    }

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            title,
            titleChinese,
            titleChineseTraditional,
            titleThai,
            titleJapanese,
            titleVietnamese,
            description,
            descriptionChinese,
            descriptionChineseTraditional,
            descriptionThai,
            descriptionJapanese,
            descriptionVietnamese,
            originalPrice,
            price,
            startDate,
            endDate,
            images,
            homeRetailOfferLoading,
            showBannerOnly
        } = this.props.homeRetailOfferStore;

        const lang = window.localStorage.getItem('lang') || 'en';
        let titleText = '';
        let descriptionText = '';

        if (lang === 'en') {
            titleText = title;
            descriptionText = description;
        } else if (lang === 'zh') {
            titleText = titleChinese;
            descriptionText = descriptionChinese;
        } else if (lang === 'zh-Hant') {
            titleText = titleChineseTraditional;
            descriptionText = descriptionChineseTraditional;
        } else if (lang === 'th') {
            titleText = titleThai;
            descriptionText = descriptionThai;
        } else if (lang === 'ja') {
            titleText = titleJapanese;
            descriptionText = descriptionJapanese;
        } else if (lang === 'vi') {
            titleText = titleVietnamese;
            descriptionText = descriptionVietnamese;
        }

        if (titleText === '') {
            titleText = title;
        }

        if (descriptionText === '') {
            descriptionText = description;
        }

        if (homeRetailOfferLoading) {
            Toast.loading('Ordering...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            {
                                webSettting
                                    ?
                                    <>
                                        <Layout className='stm-layout'>
                                            <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                            <Content>
                                                {/* Header */}
                                                <Row>
                                                    <Col
                                                        span={24}
                                                        className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                            background: activeTemplate.templateSetting.header.backgroundColor,
                                                            color: activeTemplate.templateSetting.header.color,
                                                            fontSize: activeTemplate.templateSetting.header.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                            </Col>
                                                            <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                {webSettting.shoppingOfferText}
                                                            </Col>
                                                            <Col span={4} />
                                                        </Row>
                                                    </Col>
                                                </Row>

                                                {/* Body */}
                                                <>
                                                    {
                                                        images.length > 0
                                                            ?
                                                            <>
                                                                <>
                                                                    <Row>
                                                                        <Col span={24} className={images.length === 1 ? 'stm-margin-top-50' : 'stm-margin-top-50 stm-background-black'}>
                                                                            <Carousel>
                                                                                {
                                                                                    images.map(image => {
                                                                                        return (
                                                                                            <div key={image.id} className='stm-text-align-left'>
                                                                                                <Row className='stm-text-align-left'>
                                                                                                    <Col span={24} className='stm-background-black'>
                                                                                                        <img className='stm-width-100-percent stm-height-auto' src={image.url} alt={image.id} />
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </div>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Carousel>
                                                                        </Col>
                                                                    </Row>
                                                                </>

                                                                <>
                                                                    {
                                                                        showBannerOnly
                                                                            ?
                                                                            null
                                                                            :
                                                                            <Row className='stm-margin-top-24 stm-background-white stm-padding-bottom-100'>
                                                                                <Col span={1} />
                                                                                <Col span={22}>
                                                                                    {/* Title */}
                                                                                    <div
                                                                                        className='stm-margin-bottom-16 stm-text-align-center'
                                                                                        style={{
                                                                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                            color: activeTemplate.templateSetting.label.color,
                                                                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                                                        }}
                                                                                    >
                                                                                        {titleText}
                                                                                    </div>

                                                                                    {/* Start - End Date */}
                                                                                    <Row className='stm-padding-bottom-20'>
                                                                                        <Col span={11} className='stm-text-align-right'>
                                                                                            <Tag
                                                                                                style={{
                                                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 18}px`
                                                                                                }}
                                                                                                color={activeTemplate.templateSetting.header.backgroundColor}
                                                                                            >
                                                                                                <span>{startDate}</span>
                                                                                            </Tag>
                                                                                        </Col>
                                                                                        <Col
                                                                                            span={2}
                                                                                            className='stm-text-align-center'
                                                                                            style={{
                                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                color: activeTemplate.templateSetting.text.color,
                                                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 18}px`
                                                                                            }}
                                                                                        >
                                                                                            <span>-</span>
                                                                                        </Col>
                                                                                        <Col span={11}>
                                                                                            <Tag
                                                                                                style={{
                                                                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                    fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                    lineHeight: `${activeTemplate.templateSetting.text.fontSize + 18}px`
                                                                                                }}
                                                                                                color={activeTemplate.templateSetting.header.backgroundColor}
                                                                                            >
                                                                                                <span>{endDate}</span>
                                                                                            </Tag>
                                                                                        </Col>
                                                                                    </Row>

                                                                                    {/* Current Price */}
                                                                                    <div className='stm-text-align-center stm-padding-bottom-4 stm-text-decoration-line-through'>
                                                                                        <Tag
                                                                                            style={{
                                                                                                fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                                fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                                lineHeight: `${activeTemplate.templateSetting.text.fontSize + 18}px`,
                                                                                                textDecoration: 'line-through',
                                                                                                width: 100
                                                                                            }}
                                                                                            color={'#ff4d4f'}
                                                                                        >
                                                                                            <span>{webSettting.currencyCode} {Format.Currency(originalPrice)}</span>
                                                                                        </Tag>
                                                                                    </div>

                                                                                    {/* Special Price */}
                                                                                    <div className='stm-text-align-center stm-padding-bottom-20'>
                                                                                        <Tag
                                                                                            style={{
                                                                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 18}px`,
                                                                                                width: 100
                                                                                            }}
                                                                                            color={activeTemplate.templateSetting.header.backgroundColor}
                                                                                        >
                                                                                            <span>{webSettting.currencyCode} {Format.Currency(price)}</span>
                                                                                        </Tag>
                                                                                    </div>

                                                                                    {/* Description */}
                                                                                    <div
                                                                                        style={{
                                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                                            color: activeTemplate.templateSetting.text.color,
                                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`
                                                                                        }}
                                                                                    >
                                                                                        <Markup content={descriptionText} />
                                                                                    </div>
                                                                                </Col>
                                                                                <Col span={1} />
                                                                            </Row>
                                                                    }
                                                                </>

                                                                <Row>
                                                                    <Col
                                                                        span={24}
                                                                        className='stm-position-fixed stm-bottom-0 stm-padding-bottom-15 stm-background-white stm-padding-top-15 stm-max-width-500'
                                                                    >
                                                                        <Row>
                                                                            <Col span={1} />
                                                                            <Col span={22} >
                                                                                <Button
                                                                                    className='stm-width-100-percent stm-border-radius-4 stm-height-54 stm-margin-bottom-2'
                                                                                    onClick={this.orderClick}
                                                                                    style={{
                                                                                        background: activeTemplate.templateSetting.buttonFooter.backgroundColor,
                                                                                        fontFamily: activeTemplate.templateSetting.buttonFooter.fontFamily,
                                                                                        fontSize: activeTemplate.templateSetting.buttonFooter.fontSize,
                                                                                        lineHeight: `${activeTemplate.templateSetting.buttonFooter.fontSize + 2}px`,
                                                                                        color: activeTemplate.templateSetting.buttonFooter.color
                                                                                    }}
                                                                                >
                                                                                    Order Now
                                                                                </Button>
                                                                            </Col>
                                                                            <Col span={1} />
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </>
                                            </Content>
                                        </Layout>
                                    </>
                                    :
                                    null
                            }
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default RetailOfferClientPage;